import {
  InteractionRequiredAuthError,
  BrowserAuthError,
} from '@azure/msal-browser';
import { useMsal } from '@azure/msal-react';
import {
  downloadQuery,
  useConfigLoader,
  useDownloadFile,
} from '@scts/utilities';
import { DownloadLinkProps } from '@scts/models';
import { acquireAccessToken } from '../../contexts/auth/acquire-token';
import React, { useEffect, useState } from 'react';
import { useRecoilState } from 'recoil';
import { tokenState } from '../../contexts/atoms/token-atom';
import { Button, ButtonState } from './download-button';

export const DownloadLink = (downloadLinkProps: DownloadLinkProps) => {
  const [buttonState, setButtonState] = useState<ButtonState>(
    ButtonState.Primary
  );
  const preDownloading = () => setButtonState(ButtonState.Loading);
  const postDownloading = () => setButtonState(ButtonState.Primary);
  const [showAlert, setShowAlert] = useState<boolean>(false);
  const [token, setToken] = useRecoilState(tokenState);
  const { instance, accounts } = useMsal();
  const { data } = useConfigLoader();

  useEffect(() => {
    if (data) {
      acquireAccessToken(instance, accounts[0], data?.configuration.auth.scopes)
        .then((res) => {
          if (res.accessToken !== '') {
            setToken(res.accessToken);
          } else {
            setToken('invalid'); //api won't fire and therefore not return so stuck waiting if we don't set to something
          }
        })
        .catch((error) => {
          console.log('Error: ', error);
          if (
            error instanceof InteractionRequiredAuthError ||
            error instanceof BrowserAuthError
          ) {
            const logoutRequest = {
              account: instance.getAllAccounts()[0],
              scopes: [data?.configuration.auth.scopes],
            };
            instance.logoutRedirect(logoutRequest);
          }
        });
    }
  }, [data]);

  const onErrorDownloadFile = () => {
    setShowAlert(true);
    setButtonState(ButtonState.Primary);
    setTimeout(() => {
      setShowAlert(false);
    }, 3000);
  };

  const { ref, url, download, name } = useDownloadFile({
    apiDefinition: downloadQuery,
    onError: onErrorDownloadFile,
    fileName: downloadLinkProps.fileName,
    apiUrl: downloadLinkProps.apiUrl,
    token: token,
    preDownloading,
    postDownloading,
  });
  return (
    <>
      {data && (
        <>
          <a id={name} href={url} download={name} ref={ref}>
            <Button
              label="Download"
              buttonState={buttonState}
              onClick={download}
              fileName={downloadLinkProps.fileName}
            />
          </a>

          <p
            aria-live="polite"
            className={showAlert ? 'text-danger' : 'text-danger d-none'}
          >
            Something went wrong. Please try again!
          </p>
        </>
      )}
    </>
  );
};
